import React from 'react';

import { useEvieAppContext } from 'components/evieApp/EvieAppProvider';

import UnitCard from '../UnitCard';

const ProgramContentUnits = () => {
  const { program: { programLevels = [] } = {} } = useEvieAppContext();
  return (
    <section className="program-content">
      {programLevels.map((programLevel) => (
        <UnitCard key={programLevel.id} unit={programLevel} />
      ))}
    </section>
  );
};

export default ProgramContentUnits;
